module.exports = __webpack_public_path__ + "static/media/10gym.edd454e4.svg";